import { fokaAxios } from 'app/fokaAxios'
import { upload } from 'api/axios/tenth'

export default {
  searchDspImages: ({
    name = '',
    sizeTypes = [],
    isRecentlyUsed = false,
    size = 20,
    page = 0,
  }) =>
    fokaAxios.post(
      '/api/v2/dspimages/search',
      {
        name,
        isRecentlyUsed,
        sizeTypes,
      },
      {
        params: {
          page,
          limit: size,
        },
      }
    ),
  downloadDspImages: ({ width = '', height = '' }) =>
    fokaAxios.get('/api/v2/dspimages/download', {
      params: {
        width,
        height,
      },
    }),
  postDspImages: createDspImagesCommand =>
    fokaAxios.post('/api/v2/dspimages', createDspImagesCommand),
  deleteDspImages: dspImageIds =>
    fokaAxios.delete('/api/v2/dspimages', { data: { dspImageIds } }),
  uploadImageFile: (file, onProgressChange, cancelToken) =>
    upload(
      '/api/v2/files/public-upload-url',
      file,
      {
        type: 'CREATIVE',
        filename: file.name,
      },
      onProgressChange,
      cancelToken
    ),
}
